import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// EN
import en from "./locales/en/index.json";
// TR
import tr from "./locales/tr/index.json";
// DE
import de from "./locales/de/index.json";
// AR
import ar from "./locales/ar/index.json";
// RU
import ru from "./locales/ru/index.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            "en-US": { translation: en },
            "tr-TR": { translation: tr },
            "de-DE": { translation: de },
            "ar-AE": { translation: ar },
            "ru-RU": { translation: ru }
        },
        fallbackLng: "tr-TR",
        supportedLngs: ["en-US", "tr-TR", "de-DE", "ar-AE", "ru-RU"],
        load: "currentOnly",
        detection: {
            order: ["querystring", "localStorage", "navigator"],
            caches: ["localStorage"],
            lookupQuerystring: "lng"
        },
        interpolation: { escapeValue: false },
    });

export default i18n;
